module.exports = __webpack_public_path__ + "img/clock-one-thirty.5976bdbe.svg";